<!--
 * @Descripttion: 交建通扫描登陆组件
 * @version: 3.0
 * @Author: zhangfan
 * @email: 2207044692@qq.com
 * @Date: 2024-11-27 17:21:16
 * @LastEditors: zouxin
 * @LastEditTime: 2024-12-12 17:13:12
-->
<template>
  <div class="scan-code">
    <!-- <div class="qr-close">
      <div class="icon-close" @click="closeModal"></div>
    </div> -->
    <!-- <div class="qr-title">
      <div class="qr-logo"></div>
      交建通登录
    </div> -->
    <!-- <div class="qr-tips">请使用交建通扫描二维码登录</div> -->
    <!-- <div class="qr-box">
      <div id="ercodeShow" class="ercode-box"></div>
    </div> -->
    <div id="ercodeShow" class="ercode-box"></div>
  </div>
</template>

<script>
import { scanLoginApi, getWxLoginResultApi } from '../../../api/user'
import { getQueryStringWidthUrl } from '@/utils/util'
import { setToken } from './auth'
import { mapActions } from 'vuex'
import store from '@/store'
import { UUID } from '@/utils/createUuid'

export default {
  name: 'ScanCode',
  data() {
    return {
      isShow: false,
      uuId: '',
      pollingInterval: null,
      maxAttempts: 100, // 最大尝试次数（约30秒）
      attempts: 0,
    }
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    this.stopPolling()
  },
  methods: {
    startPolling() {
      this.attempts = 0
      this.pollingInterval = setInterval(this.checkLoginStatus, 1000)
    },
    async checkLoginStatus() {
      if (this.attempts >= this.maxAttempts) {
        this.stopPolling()
        alert('登录超时，请重新扫码')
        return
      }

      try {
        const res = await getWxLoginResultApi(this.uuId)

        /* 假设成功响应格式：
        { code: 0, data: { token: 'xxx' } } // 0表示成功
        { code: 1 } // 1表示等待中 */
        if (res.data.code === 0) {
          this.stopPolling()
          this.handleLoginSuccess(res.data.data)
        }

        this.attempts++
      } catch (err) {
        console.error('轮询请求失败', err)
        this.stopPolling()
      }
    },
    stopPolling() {
      clearInterval(this.pollingInterval)
      this.pollingInterval = null
    },
    handleLoginSuccess(data) {
      // 处理登录成功逻辑，例如：
      // 1. 存储token
      localStorage.setItem('token', data.token)
      // 2. 跳转到首页
      this.$router.push('/home')
    },
    closeModal() {
      this.$emit('changeClose')
    },
    // 在方法或组合式函数中
    generateWechatUrl() {
      const baseUrl =
        'https://open.weixin.qq.com/connect/qrconnect?appid=wx275fe39f64cd200f&agentid=1002355&redirect_uri=http://wedata360.com/bicube_manage/motion/manage/wx/loginByWx&response_type=code&scope=snsapi_login'
      this.uuId = UUID()

      // 使用URL对象安全地处理参数
      const url = new URL(baseUrl)
      url.searchParams.append('state', this.uuId)

      return url.toString()
    },
    wwLogin(originUrl) {
      const frame = document.createElement('iframe')
      frame.src = originUrl
      frame.className = 'qr-frame'
      // frame.width = '180px'
      frame.height = '400px'
      const el = document.getElementById('ercodeShow')
      console.log(el)
      el.innerHTML = ''
      el.appendChild(frame)
    },
  },
  mounted() {
    const url = this.generateWechatUrl()
    this.wwLogin(url)
    this.startPolling()
  },
}
</script>

<style lang="less" scoped>
.scan-code {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // padding-bottom: 30px;
  background: #ffffff;

  .qr-title {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #ffffff;

    .qr-logo {
      width: 32px;
      height: 32px;
      margin-left: 16px;
      background-image: url('../../../assets/images/qr-logo.png');
      background-size: 100% 100%;
      margin-right: 13px;
    }
  }

  .qr-close {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: right;
    justify-content: right;

    .icon-close {
      width: 16px;
      height: 16px;
      // background-image: url('../../../assets/images/icon-close.png');
      background-image: url('../../../assets/images/close-fill.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }

  .qr-box {
    margin-top: 30px;
    width: 211px;
    // height: 211px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 5px 5px 5px 5px;
  }

  .ercode-box {
    // width: 180px;
    // height: 180px;
    position: relative;
    bottom: 3px;
    right: 2px;
  }

  .qr-tips {
    margin-top: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #6b6b6b;
  }

  .qr-text {
    font-size: 12px;
    margin-top: 4px;
    color: rgb(var(--primary-6));
  }
}
</style>

<style>
.qr-frame {
  border: none;
}
</style>
